export const iconFontAwesomeMoneyCircleDollarToSlot = (
	<i className="fa-solid fa-circle-dollar-to-slot"></i>
);
